var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('data-item',{attrs:{"breadcrumbs":_vm.breadcrumbs,"title":_vm.caption,"data-source":_vm.dataSource},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('certificate-editor',{attrs:{"data-source":_vm.dataSource}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }